<div class="not-found">
    <div class="not-found__wrapper">
        <div class="not-found__error">{{errorStatus}}</div>
        <div class="not-found__message">{{errorMessage | translate}}</div>
        <button class="not-found__btn btn" [translate]="'btns.back'" [routerLink]="['/device-dashboard']"></button>
    </div>
</div>
